import { render, staticRenderFns } from "./InstallmentOverdueState.vue?vue&type=template&id=bb6a2c6a&"
import script from "./InstallmentOverdueState.vue?vue&type=script&lang=js&"
export * from "./InstallmentOverdueState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports